import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import {
  View,
  Text,
  Dimensions,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import Colors from "../assets/Color/Colors";
import { howtoContest1 } from "../screens/contest/childComponents/contest.constants";
import CustomButton from "./CustomButton";
import { setContestVisible } from "../screens/contest/redux/contest.action";
import { useDispatch } from "react-redux";
import { globalFontStyle } from "../assets";
import { globalImport } from "../common/globalImports";
import Width from "../assets/Width";
import { back_button_big } from "../utils/images";
import FastImage from "../common/FastImage";
import { globalConst } from "../utils/globalConstant";
import FormTextLabel from "./FormTextLabel";

const ContestOnBoarding = ({ onClose }) => {
  const dispatch = useDispatch();
  const [currentSlide, setCurrentSlide] = useState(0);

  const prev = () => {
    setCurrentSlide(currentSlide - 1);
  };

  const updateCurrentSlide = (index) => {
    if (currentSlide !== index) {
      setCurrentSlide(index);
    }
  };

  const onClick = () => {
    if (currentSlide + 1 === 3) {
      window.localStorage.setItem("isContestVisible", true);
      dispatch(setContestVisible(true));
    } else {
      setCurrentSlide(currentSlide + 1);
    }
  };
  return (
    <View style={{ flex: 1 }}>
      <Carousel
        showThumbs={false}
        swipeable={true}
        emulateTouch={true}
        swipeScrollTolerance={5}
        selectedItem={currentSlide}
        onChange={updateCurrentSlide}
        showArrows={false}
        showIndicators={false}
        showStatus={false}
        autoPlay={false}
      >
        {howtoContest1.map((event) => {
          return (
            <View style={styles.screenContainerView}>
              <View style={styles.lineIndicatorDefault} />
              <View
                style={[
                  styles.lineIndicatorSelected,
                  {
                    width: (currentSlide + 1) * ((Width.width - 32) / 3),
                  },
                ]}
              />

              <FormTextLabel
                labelStyles={[
                  globalFontStyle.appFontTitleHead,
                  { color: Colors.bgWhite, marginTop: 100, textAlign: 'left', paddingRight: 30 },
                ]}
                label={event.title} />
            </View>
          );
        })}
      </Carousel>
      <View style={[styles.bottomAbsContainer, { width: Width.width - 32 }]}>
        {currentSlide > 0 ? (
          <TouchableOpacity onPress={prev}>
            <FastImage
              style={{ width: 60, height: 60, marginRight: 5 }}
              source={back_button_big()}
            />
          </TouchableOpacity>
        ) : null}
        <CustomButton
          btnText={currentSlide > 1 ? 'Get Started' : `Next (${currentSlide + 1}/3)`}
          btnType={"btnBlackNew"}
          onBtnClick={() => {
            setTimeout(() => {
              onClick();
            }, globalConst.buttonTimer);
          }}
          translate={true}
          customFontStyle={{ ...globalFontStyle.appFontSmallTextBold }}
          customStyle={[
            styles.btnStyleOnBoard,
            {
              width:
                currentSlide === 0 ? Width.width - 32 : Width.width - 32 - 65,
            },
          ]}
        />
      </View>
    </View>
  );
};

export default ContestOnBoarding;

const styles = StyleSheet.create({
  screenContainerView: {
    backgroundColor: Colors.tradexBlue,
    flex: 1,
    paddingHorizontal: 16,
    height: "100vh",
    marginBottom: 20,
  },
  btnStyleOnBoard: {
    flex: globalImport.isWeb ? {} : 0,
    borderColor: Colors.bgWhite,
    height: 55,
  },
  bottomAbsContainer: {
    position: "absolute",
    flexDirection: "row",
    bottom: 0,
    marginBottom: 30,
    paddingHorizontal: 16,
    height: 60,
    alignItems: "center",
  },
  lineIndicatorDefault: {
    borderBottomWidth: 5,
    marginTop: 20,
    borderBottomColor: "rgba(219, 219, 219, 0.30)",
  },
  lineIndicatorSelected: {
    borderBottomWidth: 5,
    marginTop: 20,
    borderBottomColor: Colors.bgWhite,
    position: "absolute",
  },
});
